import { render, staticRenderFns } from "./editIngredientModalContent.vue?vue&type=template&id=01cc9d7a&scoped=true"
import script from "./editIngredientModalContent.vue?vue&type=script&lang=js"
export * from "./editIngredientModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc9d7a",
  null
  
)

export default component.exports